<div class="modal-content">
    <div class="modal-header bg-blue4">
        <h4 class="modal-title white text-bold-600" id="myModalLabel22">{{title}}</h4>
    </div>
    <div class="modal-body">
        <h5 class="text-bold-500">Antes de publicar la oferta...</h5>
        <p class="media-body">
        Debes contemplar que esta no es visible para los demás automáticamente, antes de eso es necesario 
        que los administradores verifiquen la veracidad de la información que acabas de proporcionar 
        en el formulario para asegurarnos de que se trata de una oferta real.
        <br>Además, es probable que nos comuniquemos contigo para corroborar los datos de contacto 
        que proporcionaste.
        </p>
        <div class="bs-callout-info callout-round callout-bordered mt-1">
            <div class="media align-items-stretch">
              <div class="d-flex align-items-center media-left media-middle bg-info p-2">
                <i class="feather ft-alert-circle white font-medium-5"></i>
              </div>
              <div class="media-body p-1">
                <strong>¡Importante!</strong>
                <p>Verifica y asegúrate de que los datos de la oferta sean correctos.</p>
              </div>
            </div>
        </div>
        <p class="media-body mt-1">
          Si deseas modificar la información de la oferta, puedes retroceder utilizando los botones en la 
          parte inferior de la página.
          </p>        
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary btn-min-width mr-1 mb-1"
        (click)="activeModal.close('cancel')"><i class="feather ft-x"></i> Cancelar</button>
        <button type="button" class="btn btn-navy btn-min-width mr-1 mb-1" (click)="activeModal.close('accept')">
        <i class="feather ft-share"></i> Subir</button>
    </div>
</div>